import { Nav, Tab } from "react-bootstrap";
import useActions from "../../../../hooks/service-actions.hook";
import { StorefrontProductsEffectActions } from "../../../../common/services/storefront-products/storefront-products.service";
import { useEffect, useState } from "react";
import MyModal from "../../../Common/my-modal/my-modal.component";
import TechSpendTab from "./techspend.tab";
import StorefrontTab from "./storefront.tab";

const ClientTypeSelection = ['TechSpend', 'Storefront']

const UpdateCategoriesModal = ({ show, onHide, clientList, productList, categoryList }) => {
  const { updateStorefrontProducts } = useActions(StorefrontProductsEffectActions);

  const [storefrontState, setStorefrontState] = useState([]);
  const [defaultSelectedTab, setDefaultSelectedTab] = useState(ClientTypeSelection[0]);

  const onSave = () => {
    if (!storefrontState?.length) {
      onHide();
      return;
    }
    updateStorefrontProducts({
      productList: storefrontState?.map(item => ({
        ProductId: item.id,
        CategoryId: item.categoryId,
        SubCategoryId: item.subcategoryId,
        isPublished: item.published
      })),
    });
    onHide();
  }

  useEffect(() => {
    if (show) return;
    setDefaultSelectedTab(ClientTypeSelection[0]);
  }, [show])

  return (
    <MyModal className="update-categories-modal" show={show} onHide={onHide}>
      <MyModal.Header className="pb-1">
        <MyModal.HeaderTitle className="w-100">
          Update Categories Before Deletion
        </MyModal.HeaderTitle>
      </MyModal.Header>
      <MyModal.Body className="d-flex flex-column gap-8">
        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey={defaultSelectedTab}
          onSelect={(e) => {
            setDefaultSelectedTab(e);
          }}
        >
          <p>
            {`Currently, “${clientList?.length} client${clientList?.length !== 1 ? 's' : ''}” and “${productList?.length} product${productList?.length !== 1 ? 's' : ''}” are using this category and may have spend recorded in it. To proceed with deletion, please update the category to a different one.`}
          </p>
          <div
            className="nav-header-container d-flex justify-content-between align-items-center ml- p-0"
          >
            <Nav
              variant="pills"
              className="flex-row"
            >
              {ClientTypeSelection.map((clientType) => (
                <Nav.Item key={clientType}>
                  <Nav.Link eventKey={clientType}>{clientType}</Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </div>
          <Tab.Content className="hide-scrollbar">
            <Tab.Pane eventKey={ClientTypeSelection[0]}>
              <TechSpendTab clientList={clientList} show={show} />
            </Tab.Pane>
            <Tab.Pane eventKey={ClientTypeSelection[1]} className="overflow-hidden">
              <StorefrontTab 
                productList={productList} 
                categoryList={categoryList} 
                storefrontState={storefrontState} 
                setStorefrontState={setStorefrontState} 
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </MyModal.Body>
      <MyModal.Footer className="d-flex gap-4">
        <MyModal.CancelButton onClick={onHide}>Cancel</MyModal.CancelButton>
        <MyModal.ApplyButton onClick={onSave}>Save</MyModal.ApplyButton>
      </MyModal.Footer>
    </MyModal>
  )
}

export default UpdateCategoriesModal;
